import type { CompleteFieldSelector } from '@/types/fields-api.model';
import type { User } from '@/types/user.model';
import { RANKING_FIELDS } from '../sport/sport-fields.config';

const USER_FIELDS_MINIMAL = {
  id: true,
  name: true,
  username: true,
  hasMercadoPagoCredentials: true,
} as const;

const USER_FIELDS_BASIC = {
  ...USER_FIELDS_MINIMAL,
  email: true,
  gender: true,
  rankings: RANKING_FIELDS.BASIC,
} as const;

const USER_FIELDS_DEFAULT = {
  ...USER_FIELDS_BASIC,
  birthdate: true,
  cellphone: true,
  nationality: {
    isoCode: true,
    name: true,
    flag2: true,
    phonePrefix: true,
  },
} as const;

const USER_FIELDS_FULL: CompleteFieldSelector<User> = {
  ...USER_FIELDS_DEFAULT,
  roles: true,
  phoneToken: true,

  playerSubscription: {
    id: true,
    subscriptionType: true,
    mercadoPagoSubscriptionId: true,
    subscriptionRole: true,
  },
  managerSubscription: {
    id: true,
    subscriptionType: true,
    mercadoPagoSubscriptionId: true,
    subscriptionRole: true,
  },
  profileImageUrl: true,
  termsAccepted: true,
} as const;

const USER_FIELDS_FIND = {
  id: true,
  email: true,
  name: true,
  profileImageUrl: true,
  rankings: RANKING_FIELDS.BASIC,
} as const;

export const USER_FIELDS = {
  MINIMAL: USER_FIELDS_MINIMAL,
  BASIC: USER_FIELDS_BASIC,
  DEFAULT: USER_FIELDS_DEFAULT,
  FULL: USER_FIELDS_FULL,
  FIND: USER_FIELDS_FIND,
} as const;
